import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('Falta <div id="raiz"> en index.html')

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
